import { useEffect } from "react";
import { useFormikContext } from "formik";

const ErrorFocus = () => {
  // Get the context for the Formik form this component is rendered into.
  const { isSubmitting, isValidating, errors } = useFormikContext();

  useEffect(() => {
    // Get all keys of the error messages.
    const keys = Object.keys(errors)[0];
    let nestedKeys;
    if ((keys && keys === "healthInsurances") || keys === "otherDriverInsuranceFields") {
      // console.log(keys);
      errors[keys].forEach((ele, ind) => {
        // console.log(ele, "ele", ind, "ind");
        nestedKeys = errors[keys][ind] && Object.keys(errors[keys][ind]);
        return;
      });
      // console.log("errors is", errors);
      // console.log("nestedKeys is ", nestedKeys);
    } else if (keys) {
      nestedKeys = Object.keys(errors[keys]);
    }

    // Whenever there are errors and the form is submitting but finished validating.
    if (
      keys &&
      keys.length > 0 &&
      nestedKeys &&
      nestedKeys.length > 0 &&
      isSubmitting &&
      !isValidating
    ) {
      let name = `${keys}.${nestedKeys[0]}`;

      let errorElement;
      // console.log(name);
      if ((keys && keys === "healthInsurances") || keys === "otherDriverInsuranceFields") {
        errors[keys].forEach((ele, ind) => {
          let fieldName = name.split(".")[1];
          // console.log(fieldName, "fieldName");
          errorElement =
            keys === "healthInsurances"
              ? document.querySelector(`input[name="${keys}[${[ind]}].${fieldName}"]`)
              : keys === "otherDriverInsuranceFields"
              ? document.querySelector(`input[name="${keys}[${[ind]}][${fieldName}]"]`)
              : "";
          // console.log(`name="${keys}[${[ind]}].${fieldName}"`);
          // console.log(ele, ind, "Ele & ind");
          return;
        });

        console.log(errorElement, "error element field array");
      } else {
        errorElement = document.querySelector(`input[name="${name}"]`);
        console.log(errorElement, "error element normal");
      }
      // We grab the first input element that error by its name.

      if (errorElement) {
        // When there is an input, scroll this input into view.
        errorElement.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [isSubmitting, isValidating, errors]);

  // This component does not render anything by itself.
  return null;
};

// Standard Algo for nested elements can be used in future
// const keyify = (obj, prefix = '') =>
//   Object.keys(obj).reduce((res, el) => {
//     if (Array.isArray(obj[el])) {
//       return res
//     }

//     if (typeof obj[el] === 'object' && obj[el] !== null) {
//       return [...res, ...keyify(obj[el], `${prefix}${el}.`)]
//     }

//     return [...res, prefix + el]
//   })

export default ErrorFocus;
